import {
	useSaveTemplateMutation,
	useGetOrgInfoQuery,
	useUpdateOrgSettingsMutation,
	useLoadTemplateQuery
	} from './redux/databaseView';

import {
	useEffect,
	useState,
	useRef
	} from 'react';

import * as React from 'react';
import PropTypes from 'prop-types';

import {WaitingElement} from './AddUserDialog';

import {
	Stack,
	TextField,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	IconButton,
	Button,
	Alert,
	Tabs,
	Tab,
	Box,
	Typography
	} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import {MuiColorInput} from 'mui-color-input';

import {
	warningItems,
	functionalAreas
	} from './SystemDefaults.js';

import $ from 'jquery';


/*
 * Common tab components
 */

function CustomTabPanel(props)
	{
	const {
		children,
		value,
		index,
		...other
		}=props;

	return (
		<div
			role="tabpanel"
			hidden={value!==index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value===index &&
				<Box sx={{pt:3}}>
					{children}
				</Box>
			}
		</div>
		);
	}


CustomTabPanel.propTypes=
	{
	children:PropTypes.node,
	index:PropTypes.number.isRequired,
	value:PropTypes.number.isRequired
	};


function a11yProps(index)
	{
	return {
		id:`simple-tab-${index}`,
		'aria-controls':`simple-tabpanel-${index}`
		};
	}


/*
 * Standard settings card
 */

function SettingsCard(
	{
	title,
	description,
	children
	})
	{
	return (
		<Paper
			variant="outlined"
			sx={{
				p:{
					xs:2,
					sm:3
					},
				borderRadius:2
				}}
		>
			{title &&
				<Box sx={{mb:3,textAlign:'left'}}>
					<Typography
						variant="h6"
						sx={{
							fontWeight:600
							}}
					>
						{title}
					</Typography>

					{description &&
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{mt:0.5}}
						>
							{description}
						</Typography>
					}
				</Box>
			}

			{children}
		</Paper>
		);
	}


/*
 * Simple settings table
 */

function SSTable(
	{
	elementNode,
	deleteRow
	})
	{
	var rows=elementNode.rows;

	return (
		<TableContainer
			component={Paper}
			variant="outlined"
			sx={{
				boxShadow:'none'
				}}
		>
			<Table
				size="small"
				sx={{width:'100%'}}
				aria-label="settings table"
			>
				<TableHead>
					<TableRow>
						{
						elementNode.columns.map((x)=>
							{
							return (
								<TableCell
									key={x.key}
									align={
										x.key==="delete"
											?"right"
											:"left"
										}
									sx={{
										fontWeight:600,
										backgroundColor:'action.hover'
										}}
								>
									{x.label}
								</TableCell>
								);
							})
						}
					</TableRow>
				</TableHead>

				<TableBody>
					{
					rows.map((row,idx)=>
						{
						return (
							<TableRow
								key={"row"+idx}
								hover
								sx={{
									'&:last-child td, &:last-child th':
										{
										border:0
										}
									}}
							>
								{
								elementNode.columns.map((x)=>
									{
									if (x.key==="delete")
										{
										return (
											<TableCell
												key={x.key}
												align="right"
											>
												<IconButton
													color="error"
													size="small"
													aria-label="Delete"
													onClick={()=>
														deleteRow(idx)
														}
												>
													<DeleteIcon />
												</IconButton>
											</TableCell>
											);
										}

									return (
										<TableCell
											key={x.key}
										>
											{row[x.key]}
										</TableCell>
										);
									})
								}
							</TableRow>
							);
						})
					}
				</TableBody>
			</Table>
		</TableContainer>
		);
	}


/*
 * Email template editor
 */

export function EmailBuilder({type}) 
	{
	const editorRef = useRef(null);
	const [content, setContent] = useState(null);
	const [saveTemplate,{ isLoading: isUpdating }]=useSaveTemplateMutation();
	const {data:oldtemplate,isFetching}=useLoadTemplateQuery({type});

	function save()
		{
		saveTemplate({type,template:(content)});
		}

	var actionText="Loading";

	if (isUpdating)
		actionText="Saving";

	useEffect(() => {
		if (!editorRef.current) 
			return;

		const $editor = $(editorRef.current);

		if (isFetching)
			return;

		$editor.summernote({
		  height: 300,
		  fontsize: 16,
		  placeholder: 'Type your email content here...',
		  tooltip: false,
		  dialogsInBody: true,
		  toolbar: [
			['style', ['bold', 'italic', 'underline', 'clear']],
			['font', ['strikethrough', 'superscript', 'subscript']],
			['fontsize', ['fontsize']],
			['color', ['color']],
			['para', ['ul', 'ol', 'paragraph']],
			['insert', ['link', 'picture', 'table', 'hr']],
			['view', ['fullscreen', 'codeview', 'help']],
			['undo', ['undo', 'redo']]
		  ],
		  callbacks: {
			onInit: function (){
				if (oldtemplate?.data?.template)
					$editor.summernote('code', oldtemplate.data.template);
				},
			onChange: (contents) => setContent(contents),
			onImageUpload: (files) => {
			  Array.from(files).forEach((file) => {
				const reader = new FileReader();
				reader.onloadend = () => {
				  const base64 = reader.result;
				  $editor.summernote('insertImage', base64, file.name);
				};
				reader.readAsDataURL(file);
			  });
			},
		  },
		});

		return () => $editor.summernote('destroy');
	  }, [editorRef,isFetching,oldtemplate?.data?.template]);

	return (
		<WaitingElement actionText={actionText} waiting={isUpdating||isFetching}>
			<div style={{ maxWidth: '900px', margin: '20px auto' }}>
				<style>{`
					.note-editable  {
						text-align: left !important;
					}
				`}
				</style>

				<div ref={editorRef} />

				<div style={{paddingTop:20}}>
					<Button
						variant="contained"
						onClick={save}
						style={{
							float:'right',
							paddingLeft:10,
							paddingRight:10
							}}
					>
						Save
					</Button>
					<div style={{flex:1}}/>
				</div>
			</div>
		</WaitingElement>
		);
	}
/*
 * Functional Areas
 */

function AreaSettingsTab(
	{
	save,
	rows,
	setRows
	})
	{
	const [newArea,setNewArea]=useState("");
	const [errorText,setErrorText]=useState(null);


	function addRow()
		{
		const area=newArea.trim();

		if (!area)
			return;

		if (
			rows.some((x)=>
				x.area.toLowerCase()===area.toLowerCase()
				)
			)
			{
			setErrorText(
				"Area already exists in table"
				);

			return;
			}

		setErrorText(null);

		setRows([
			...rows,
			{
			area:area
			}
			]);

		setNewArea("");
		}


	function deleteRow(idx)
		{
		var newRows=[...rows];

		newRows.splice(idx,1);

		setRows(newRows);
		}


	function keyDown(e)
		{
		if (e.key==="Enter")
			{
			e.preventDefault();
			addRow();
			}
		}


	return (
		<SettingsCard
			title="Functional Areas"
			description="Manage the functional areas used for user and workflow assignments."
		>
			<Stack
				direction={{
					xs:'column',
					sm:'row'
					}}
				spacing={2}
				alignItems="flex-start"
				sx={{mb:3}}
			>
				<TextField
					label="New functional area"
					value={newArea}
					onChange={(e)=>
						{
						setNewArea(e.target.value);

						if (errorText!==null)
							setErrorText(null);
						}}
					onKeyDown={keyDown}
					error={errorText!==null}
					helperText={errorText}
					size="small"
					sx={{
						width:350,
						maxWidth:'100%'
						}}
				/>

				<Button
					disabled={!newArea.trim()}
					variant="contained"
					onClick={addRow}
					sx={{
						height:40,
						whiteSpace:'nowrap'
						}}
				>
					Add Area
				</Button>
			</Stack>

			<SSTable
				deleteRow={deleteRow}
				elementNode={{
					columns:[
						{
						key:"area",
						label:"Functional Area"
						},
						{
						key:"delete",
						label:""
						}
						],
					rows:rows
					}}
			/>

			<Box
				sx={{
					display:'flex',
					justifyContent:'flex-end',
					mt:3
					}}
			>
				<Button
					variant="contained"
					onClick={save}
				>
					Save Changes
				</Button>
			</Box>
		</SettingsCard>
		);
	}


/*
 * Dashboard warning settings
 */

function DashboardSettingsTab(
	{
	save,
	warnings,
	warningVersion
	})
	{
	function updateItem(name,value)
		{
		var newWarnings=warnings.current.map((x)=>
			{
			if (x.name===name)
				{
				return {
					...x,
					...value
					};
				}

			return x;
			});

		warnings.current=newWarnings;
		}


	function WarningItem(
		{
		name,
		time,
		color,
		updateItem
		})
		{
		const [days,setDays]=useState(time);
		const [tone,setTone]=useState(color);


		useEffect(()=>
			{
			updateItem({
				days:days,
				color:tone
				});

			},[
				days,
				tone
				]);


		return (
			<Box
				sx={{
					display:'grid',
					gridTemplateColumns:{
						xs:'1fr',
						sm:'minmax(180px, 1fr) 200px 200px'
						},
					gap:2,
					alignItems:'center',
					py:2,
					borderBottom:1,
					borderColor:'divider',
					'&:last-of-type':
						{
						borderBottom:0
						}
					}}
			>
				<Typography
					sx={{
						fontWeight:500,
						textAlign:'left'
						}}
				>
					{name}
				</Typography>

				<TextField
					label="Warning window"
					value={days}
					onChange={(e)=>
						setDays(e.target.value)
						}
					error={
						isNaN(days)||
						days===""
						}
					helperText={
						isNaN(days)||
						days===""
							?"Must be numeric"
							:""
						}
					size="small"
					fullWidth
				/>

				<MuiColorInput
					isAlphaHidden={true}
					format="hex"
					value={tone}
					onChange={setTone}
					size="small"
				/>
			</Box>
			);
		}


	return (
		<SettingsCard
			title="Dashboard Warnings"
			description="Configure when dashboard warnings are shown and the colour used for each warning."
		>
			<Box>
				{
				warnings.current.map((x)=>
					{
					return (
						<WarningItem
							key={
								x.name+
								"-"+
								warningVersion
								}
							name={x.name}
							color={x.color}
							time={x.days}
							updateItem={(val)=>
								updateItem(
									x.name,
									val
									)
								}
						/>
						);
					})
				}
			</Box>

			<Box
				sx={{
					display:'flex',
					justifyContent:'flex-end',
					mt:3
					}}
			>
				<Button
					variant="contained"
					onClick={save}
				>
					Save Changes
				</Button>
			</Box>
		</SettingsCard>
		);
	}


/*
 * Main site settings
 */

export default function BasicTabs()
	{
	const [value,setValue]=React.useState(0);

	const [
		updateOrgSettings
		]=useUpdateOrgSettingsMutation();

	const {
		isFetching,
		data:orgData
		}=useGetOrgInfoQuery();

	const [
		warningVersion,
		setWarningVersion
		]=useState(0);

	const warnings=useRef(warningItems);

	const [
		alertText,
		setAlertText
		]=useState(null);

	const [
		severity,
		setSeverity
		]=useState("error");

	const [
		rows,
		setRows
		]=useState(functionalAreas);


	useEffect(()=>
		{
		if (isFetching)
			return;

		if (orgData?.data?.siteSettings==null)
			return;

		const siteSettings=
			JSON.parse(
				orgData.data.siteSettings
				);

		setRows(
			siteSettings.functionalAreas
			);

		warnings.current=
			siteSettings.warnings;

		setWarningVersion((x)=>
			x+1
			);

		},[
			isFetching,
			orgData
			]);


	function handleChange(event,newValue)
		{
		setValue(newValue);
		}


	async function save()
		{
		try
			{
			await updateOrgSettings(
				{
				siteSettings:JSON.stringify(
					{
					functionalAreas:rows,
					warnings:warnings.current
					})
				}
				).unwrap();

			setSeverity("success");
			setAlertText(
				"Settings saved successfully."
				);
			}
		catch (error)
			{
			setSeverity("error");
			setAlertText(
				"Unable to save settings."
				);
			}
		}


	return (
		<WaitingElement waiting={isFetching}>
			<Box
				sx={{
					width:'100%',
					maxWidth:1100,
					mx:'auto',
					px:{
						xs:2,
						sm:3
						},
					py:3
					}}
			>
				<Box
					sx={{
						mb:3,
						textAlign:'left'
						}}
				>
					<Typography
						variant="h5"
						sx={{
							fontWeight:600
							}}
					>
						Site Settings
					</Typography>

					<Typography
						variant="body2"
						color="text.secondary"
						sx={{mt:0.5}}
					>
						Configure organisation settings,
						dashboard warnings and email templates.
					</Typography>
				</Box>

				<Box
					sx={{
						borderBottom:1,
						borderColor:'divider'
						}}
				>
					<Tabs
						value={value}
						onChange={handleChange}
						variant="scrollable"
						scrollButtons="auto"
						aria-label="Site settings"
					>
						<Tab
							label="Functional Areas"
							{...a11yProps(0)}
						/>

						<Tab
							label="Dashboard"
							{...a11yProps(1)}
						/>

						<Tab
							label="New User Email"
							{...a11yProps(2)}
						/>

						<Tab
							label="Password Reset Email"
							{...a11yProps(3)}
						/>

						<Tab
							label="Welcome Email"
							{...a11yProps(4)}
						/>
					</Tabs>
				</Box>

				{!!alertText &&
					<Alert
						severity={severity}
						onClose={()=>
							setAlertText(null)
							}
						sx={{mt:2}}
					>
						{alertText}
					</Alert>
				}

				<CustomTabPanel
					value={value}
					index={0}
				>
					<AreaSettingsTab
						save={save}
						rows={rows}
						setRows={setRows}
					/>
				</CustomTabPanel>

				<CustomTabPanel
					value={value}
					index={1}
				>
					<DashboardSettingsTab
						save={save}
						warnings={warnings}
						warningVersion={
							warningVersion
							}
					/>
				</CustomTabPanel>

				<CustomTabPanel
					value={value}
					index={2}
				>
					<EmailBuilder
						type="newUser"
					/>
				</CustomTabPanel>

				<CustomTabPanel
					value={value}
					index={3}
				>
					<EmailBuilder
						type="forgotPass"
					/>
				</CustomTabPanel>

				<CustomTabPanel
					value={value}
					index={4}
				>
					<EmailBuilder
						type="welcome"
					/>
				</CustomTabPanel>
			</Box>
		</WaitingElement>
		);
	}


/*
 * Public component
 */

export function SiteSettings()
	{
	return (
		<BasicTabs />
		);
	}